// ─────────────────────────────────────────────────────────────────────────────
// Customer Emails Selectors
// ─────────────────────────────────────────────────────────────────────────────
// NgRx selectors for the customerEmails store slice.
// Per-customer selectors are factory selectors (mirror selectCanDo pattern in
// core/store/permissions/permissions.selectors.ts).
// ─────────────────────────────────────────────────────────────────────────────

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CustomerEmailsState } from './customer-emails.reducers';

// ── Feature selector ─────────────────────────────────────────────────────────

export const selectCustomerEmails = createFeatureSelector<CustomerEmailsState>('customerEmails');

// ── Per-customer selectors (factory) ─────────────────────────────────────────

export const selectCustomerEmailsErp = (customerId: number) =>
  createSelector(selectCustomerEmails, (state) => state.byCustomerId[customerId]?.erp ?? []);

export const selectCustomerEmailsVolta = (customerId: number) =>
  createSelector(selectCustomerEmails, (state) => state.byCustomerId[customerId]?.volta ?? []);

export const selectCustomerEmailsLoadingFor = (customerId: number) =>
  createSelector(selectCustomerEmails, (state) => state.loadingCustomerId === customerId);

// ── Global selectors ─────────────────────────────────────────────────────────

export const selectCustomerEmailsLastMutationError = createSelector(selectCustomerEmails, (state) => state.lastMutationError);
